export default __webpack_public_path__ + "static/media/potato-24.b63f3b31.png";